<template>
  <div class="container">
    <home-common-search :from='"home"'></home-common-search>
    <div  v-for='(editablePageConfig,key) in editablePageConfigList' :key="key">
      <model1 v-if='editablePageConfig.editable_page_model_id==1' v-bind:editablePageConfig="editablePageConfig"></model1>
      <model2 v-if='editablePageConfig.editable_page_model_id==2' v-bind:editablePageConfig="editablePageConfig"></model2>
      <model6 v-if='editablePageConfig.editable_page_model_id==6' v-bind:editablePageConfig="editablePageConfig"></model6>
      <model12 v-if='editablePageConfig.editable_page_model_id==12' v-bind:editablePageConfig="editablePageConfig"></model12>
      <model13 v-if='editablePageConfig.editable_page_model_id==13' v-bind:editablePageConfig="editablePageConfig"></model13>
      <model14 v-if='editablePageConfig.editable_page_model_id==14' v-bind:editablePageConfig="editablePageConfig"></model14>
      <model15 v-if='editablePageConfig.editable_page_model_id==15' v-bind:editablePageConfig="editablePageConfig"></model15>
      <model19 v-if='editablePageConfig.editable_page_model_id==19' v-bind:editablePageConfig="editablePageConfig"></model19>
      <model20 v-if='editablePageConfig.editable_page_model_id==20' v-bind:editablePageConfig="editablePageConfig"></model20>
    </div>
  </div>
</template>
<script type="application/javascript">
import { Toast } from 'mint-ui'
import { mapState, mapMutations } from 'vuex'
import HomeCommonSearch from '../common/HomeCommonSearch'
import { getEditablePageConfigList } from '../../../api/homeindex'
import Model1 from './editable_page_model/Model1'
import Model2 from './editable_page_model/Model2'
import Model6 from './editable_page_model/Model6'
import Model12 from './editable_page_model/Model12'
import Model13 from './editable_page_model/Model13'
import Model14 from './editable_page_model/Model14'
import Model15 from './editable_page_model/Model15'
import Model19 from './editable_page_model/Model19'
import Model20 from './editable_page_model/Model20'
export default {
  name: 'SpecialIndex',
  data () {
    return {
      editablePage: {},
      editablePageConfigList: []
    }
  },
  props: ['pagePath', 'itemId'],
  components: {
    HomeCommonSearch,
    Model1,
    Model2,
    Model6,
    Model12,
    Model13,
    Model14,
    Model15,
    Model19,
    Model20
  },
  computed: {
    ...mapState({
      special: state => state.home.special
    })
  },
  mounted () {},
  created: function () {
    var special_id = this.$route.query.special_id
    if (!special_id && !this.pagePath) {
      Toast('Missing parameters')
      return
    }
    getEditablePageConfigList(special_id, this.pagePath, this.itemId).then(res => {
      this.editablePage = res.result.editable_page
      this.editablePageConfigList = res.result.editable_page_config_list
      if (this.pagePath) {
        this.saveHomeSpecial({ pagePath: this.pagePath, storeId: '', itemId: this.itemId, editablePage: this.editablePage, editablePageConfigList: this.editablePageConfigList })
      }
    }).catch(function (error) {
      Toast(error.message)
    })
  },
  methods: {
    ...mapMutations({
      saveHomeSpecial: 'saveHomeSpecial'
    })
  }
}
</script>
